import { jsx, jsxs, Fragment } from "../../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.es.js";
import { MuiClassCollection } from "../../foundations/mui-class-collection.es.js";
import { Spacing } from "../../foundations/spacing.es.js";
import { theme } from "../../foundations/theme.es.js";
import "../../../node_modules/@bonusx-global/bx-icons/dist/node_modules/react/jsx-runtime.es.es.js";
import "../../../node_modules/@bonusx-global/bx-icons/dist/node_modules/@emotion/react/dist/emotion-element-c39617d8.browser.esm.es.es.js";
import "react";
import "../../../node_modules/@bonusx-global/bx-icons/dist/node_modules/hoist-non-react-statics/dist/hoist-non-react-statics.cjs.es.es.js";
import "../../../node_modules/@bonusx-global/bx-icons/dist/node_modules/@emotion/serialize/dist/emotion-serialize.browser.esm.es.es.js";
import { styled } from "@mui/material";
import { AngleDownSmallOutlined as i } from "../../../node_modules/@bonusx-global/bx-icons/dist/src/icons/outlined/angle-down-small-outlined.es.es.js";
import "../../../node_modules/@bonusx-global/bx-icons/dist/src/icons/solid/turn-icons.es.es.js";
import { MuiAccordionContainer, MuiAccordionSummaryContainer, MuiAccordionSummaryContentContainer, EndItemsContainer, ContainerWithMarginRight, ContainerWithTopSpacing } from "./components/components.es.js";
import Typography from "../../../node_modules/@mui/material/Typography/Typography.es.js";
import MuiAccordionDetails from "../../../node_modules/@mui/material/AccordionDetails/AccordionDetails.es.js";
import { IconButton } from "../icon-button/icon-button.es.js";
import { Direction } from "../../foundations/direction.es.js";
const AccordionContainerStyled = styled(MuiAccordionContainer)({
  [`&.${MuiClassCollection.disabled}`]: {
    backgroundColor: "transparent",
    cursor: "not-allowed !important",
    "> *": {
      cursor: "not-allowed !important"
    }
  }
});
function Accordion({
  children,
  isMobile,
  accordionDetailsProps,
  title,
  subtitle,
  ...rest
}) {
  const {
    id,
    startIcon,
    defaultExpanded,
    endChip,
    endAction,
    iconButtonId
  } = rest;
  const flexDirection = isMobile ? Direction.column : Direction.row;
  const shouldBeExpandable = endAction === void 0;
  const secondaryTypographyVariant = isMobile ? theme.typography.body2 : theme.typography.body1;
  const subtitleElement = typeof subtitle === "string" ? /* @__PURE__ */ jsx(Typography, { sx: {
    ...secondaryTypographyVariant,
    marginLeft: isMobile ? Spacing["0"] : Spacing["500"]
  }, children: subtitle }) : subtitle;
  return /* @__PURE__ */ jsxs(AccordionContainerStyled, { "data-testid": rest.id, isMobile, square: false, defaultExpanded, ...rest, children: [
    /* @__PURE__ */ jsxs(MuiAccordionSummaryContainer, { expandIcon: shouldBeExpandable && /* @__PURE__ */ jsx(IconButton, { id: iconButtonId || "accordion-icon-id", color: "default", size: "medium", children: /* @__PURE__ */ jsx(i, {}) }), "aria-controls": "accordion-content", id, isMobile, shouldBeExpandable, children: [
      startIcon && /* @__PURE__ */ jsx(ContainerWithMarginRight, { children: startIcon }),
      /* @__PURE__ */ jsxs(MuiAccordionSummaryContentContainer, { children: [
        /* @__PURE__ */ jsxs("div", { style: {
          display: "inherit",
          flexDirection
        }, children: [
          title,
          subtitle ? subtitleElement : /* @__PURE__ */ jsx(Fragment, {}),
          isMobile ? /* @__PURE__ */ jsx(ContainerWithTopSpacing, { children: endChip }) : /* @__PURE__ */ jsx(Fragment, {})
        ] }),
        /* @__PURE__ */ jsxs(EndItemsContainer, { shouldBeExpandable, children: [
          isMobile ? /* @__PURE__ */ jsx(Fragment, {}) : /* @__PURE__ */ jsx(ContainerWithMarginRight, { children: endChip }),
          endAction
        ] })
      ] })
    ] }),
    /* @__PURE__ */ jsx(MuiAccordionDetails, { ...accordionDetailsProps, children })
  ] });
}
export {
  Accordion
};
//# sourceMappingURL=accordion.es.js.map
